import { useFetchProfile } from '@/hooks/useFetchProfile'
import { cn } from '@/lib/utils'

/**
 * How a slash command invocation (`/name[@npub]`) is displayed everywhere:
 * in the editor, in the composer preview and in published events.
 */
export default function SlashCommandChip({
  name,
  npub,
  className,
  onClick
}: {
  name: string
  npub?: string
  className?: string
  onClick?: (e: React.MouseEvent) => void
}) {
  return (
    <span className={cn('text-primary', onClick && 'cursor-pointer', className)} onClick={onClick}>
      <span className="font-semibold">/{name}</span>
      {npub && <SlashCommandExecutor npub={npub} />}
    </span>
  )
}

function SlashCommandExecutor({ npub }: { npub: string }) {
  const { profile } = useFetchProfile(npub)
  const name = (profile?.shortName ?? npub).replace(/^@+/, '')
  return <span className="text-sm font-light">@{name}</span>
}
